import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import i18n from './modules/i18n'
import notices from './modules/notices'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import view from './modules/view'
import app from './modules/app'

Vue.use(Vuex)
interface State {
  i18n: typeof i18n.state
  notices: typeof notices.state
  permission: typeof permission.state
  tagsView: typeof tagsView.state
  user: typeof user.state
  view: typeof view.state
  app: typeof app.state
}
// 将 getter 函数转换成 {getterName: getterFuncsReturnType} 的对象类型
export type ReturnGetters<T extends { [key: string]: (...args: any) => any }> = {
  [P in keyof T]: ReturnType<T[P]>
}
type GettersFuncs = any

type Getters = ReturnGetters<GettersFuncs>
// 提取 mutation 函数类型
type CommitFuncs = typeof i18n.mutations &
  typeof notices.mutations &
  typeof permission.mutations &
  typeof tagsView.mutations &
  typeof user.mutations &
  typeof view.mutations &
  typeof app.mutations

interface Commit {
  <T extends keyof CommitFuncs>(type: T, payload?: Parameters<CommitFuncs[T]>[1]): void
}
// dispatch 处理步骤同 commit
type DispatchFuncs = typeof i18n.actions &
  typeof notices.actions &
  typeof permission.actions &
  typeof tagsView.actions &
  typeof user.actions &
  typeof view.actions &
  typeof app.actions
interface Dispatch {
  <T extends keyof DispatchFuncs>(type: T, payload?: Parameters<DispatchFuncs[T]>[1]): Promise<any>
}

const store = new Vuex.Store<State>({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    i18n,
    notices,
    permission,
    tagsView,
    user,
    view,
    app,
  },
  getters,
})

export default store

// 导出类型 Store 以便在 Vue 原型上定义类型
export interface Store {
  state: State
  getters: Getters
  commit: Commit
  dispatch: Dispatch
}
